/* unplugin-vue-components disabled */import script from "./AccountKpis.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountKpis.vue?vue&type=script&setup=true&lang=js"

import "./AccountKpis.vue?vue&type=style&index=0&id=14989e20&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14989e20"]])

export default __exports__